// in react-webapp there is a respective util: doesStringContainHtml.ts
module.exports = function doesStringContainHtml(value) {
    if (!value) {
        return false
    }

    return /<[a-z]+[\s\S]*\/?\s*>/i.test(value)
}
